import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useRef, useState } from 'react';
import { BackdropLoader, ExpandedTooltip, Icon, toast, InputWithIcon } from '@livable/saas-react-components';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography, Grid, TextField, FormControl, InputLabel, OutlinedInput, InputAdornment, IconButton, FormHelperText, ToggleButton, ToggleButtonGroup, Paper, Alert } from '@mui/material';
import { useFormik } from 'formik';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import InputMask from 'react-input-mask';
import { useStore } from 'src/stores';
import { newTeamMemberSchema, newTeamMemberValues } from 'src/utils/formValidation/NewTeamMember';
import { YEmailValidateDefault } from 'src/utils/formValidation/yupValidators';
import { translate } from 'src/utils/translator';
import useStyles from './styles';
import { PortfolioAccordionItem } from './PortfolioAccordionItem';
import { beforeSubmitDataValidation } from 'src/core/services/beforeSubmitDataValidation';
import { arrayDiff } from 'src/utils/arrayHelpers';
import { USER_ROLES_BY_NAME } from 'src/constants/userSetting';
import warningImg from 'src/img/warning.svg';
export const ModalContent = observer(_ref => {
  var _formik$values, _formik$values2, _portfoliosData$filte;
  let handleModalClose = _ref.handleModalClose,
    triggerRefresh = _ref.triggerRefresh;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpenInternal = _useState2[0],
    setIsOpenInternal = _useState2[1];
  const emailTooltipText = t('add_new_property_flow.invite_to_the_system');

  // NOTE: for assigning team member to portfolio or property
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const setTeamMemberAccess = async _ref2 => {
    let accountId = _ref2.accountId,
      userRole = _ref2.userRole,
      propertyIds = _ref2.propertyIds,
      portfolioId = _ref2.portfolioId;
    await store.account.setTeamMemberAccessAsync.run({
      accountId,
      userRole,
      propertyIds,
      portfolioId
    });
  };

  // NOTE: for assigning portfolio or property to team members
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const assignResourceTeamMember = async _ref3 => {
    let propertyId = _ref3.propertyId,
      portfolioId = _ref3.portfolioId,
      accountId = _ref3.accountId;
    await store.account.assignResourceTeamMemberAsync.run({
      propertyId,
      portfolioId,
      accountId
    });
  };
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  const _useState5 = useState({
      isInvalid: false,
      isValidating: false,
      showWarning: false
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    emailValidation = _useState6[0],
    setEmailValidation = _useState6[1];
  /** Holds the in-flight email validation, so submit can wait for a check started by the blur it caused. */
  const emailValidationRef = useRef(null);
  const _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    searchKey = _useState8[0],
    setSearchKey = _useState8[1];
  const _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    portfoliosData = _useState0[0],
    setPortfoliosData = _useState0[1];
  const _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    grantedProperties = _useState10[0],
    setGrantedProperties = _useState10[1];
  const _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    grantedPortfolios = _useState12[0],
    setGrantedPortfolios = _useState12[1];
  const handleGrantAccess = (propertyId, portfolioId) => {
    if (!!propertyId) {
      var _portfolioData$proper;
      const portfolioData = portfoliosData.find(portfolio => portfolio.id === portfolioId);
      if ((portfolioData === null || portfolioData === void 0 || (_portfolioData$proper = portfolioData.properties) === null || _portfolioData$proper === void 0 ? void 0 : _portfolioData$proper.length) === 0) {
        return false;
      }
      let updatedPropertiesList;
      const matchingItemIndex = grantedProperties !== null && !!(grantedProperties !== null && grantedProperties !== void 0 && grantedProperties.length) ? grantedProperties.findIndex(item => item === propertyId) : -1;
      if (portfolioData !== null && portfolioData !== void 0 && portfolioData.id && grantedPortfolios.findIndex(i => portfolioData.id === i) !== -1) {
        setGrantedPortfolios([...grantedPortfolios.filter(id => id !== portfolioId)]);
        setGrantedProperties([...grantedProperties, ...(portfolioData === null || portfolioData === void 0 ? void 0 : portfolioData.properties.map(i => i.propertyId).filter(i => i !== propertyId))]);
        return;
      }
      if (matchingItemIndex === -1) {
        if (grantedProperties === null || !(grantedProperties !== null && grantedProperties !== void 0 && grantedProperties.length)) {
          // setGrantedProperties([propertyId]);
          updatedPropertiesList = [propertyId];
        } else if (!!(grantedProperties !== null && grantedProperties !== void 0 && grantedProperties.length)) {
          // setGrantedProperties([...grantedProperties, propertyId]);
          updatedPropertiesList = [...grantedProperties, propertyId];
        }
        setGrantedProperties([...updatedPropertiesList]);
        const someRes = arrayDiff(portfolioData === null || portfolioData === void 0 ? void 0 : portfolioData.properties.map(i => i.propertyId), updatedPropertiesList);
        if ((someRes === null || someRes === void 0 ? void 0 : someRes.length) === 0) {
          const matchingItemIndexFix = grantedPortfolios !== null && !!(grantedPortfolios !== null && grantedPortfolios !== void 0 && grantedPortfolios.length) ? grantedPortfolios.findIndex(item => item === portfolioId) : -1;
          if (matchingItemIndexFix === -1) {
            if (grantedPortfolios === null || !(grantedPortfolios !== null && grantedPortfolios !== void 0 && grantedPortfolios.length)) {
              setGrantedPortfolios([portfolioId]);
            } else if (!!(grantedPortfolios !== null && grantedPortfolios !== void 0 && grantedPortfolios.length)) {
              setGrantedPortfolios([...grantedPortfolios, portfolioId]);
            }
          } else {
            setGrantedPortfolios([...grantedPortfolios.filter(id => id !== portfolioId)]);
          }
          setGrantedProperties([...grantedProperties.filter(id => !(portfolioData !== null && portfolioData !== void 0 && portfolioData.properties.map(i => i.propertyId).includes(id)))]);
        }
      } else {
        setGrantedProperties([...grantedProperties.filter(id => id !== propertyId)]);
      }
    }
    if (!!portfolioId && !propertyId) {
      const matchingItemIndex = grantedPortfolios !== null && !!(grantedPortfolios !== null && grantedPortfolios !== void 0 && grantedPortfolios.length) ? grantedPortfolios.findIndex(item => item === portfolioId) : -1;
      if (matchingItemIndex === -1) {
        if (grantedPortfolios === null || !(grantedPortfolios !== null && grantedPortfolios !== void 0 && grantedPortfolios.length)) {
          setGrantedPortfolios([portfolioId]);
        } else if (!!(grantedPortfolios !== null && grantedPortfolios !== void 0 && grantedPortfolios.length)) {
          setGrantedPortfolios([...grantedPortfolios, portfolioId]);
        }
        // NOTE: clear portfolio related properties
        if (grantedProperties && !!(grantedProperties !== null && grantedProperties !== void 0 && grantedProperties.length)) {
          const portfolioData = portfoliosData.find(portfolio => portfolio.id === portfolioId);
          setGrantedProperties([...grantedProperties.filter(id => !(portfolioData !== null && portfolioData !== void 0 && portfolioData.properties.map(i => i.propertyId).includes(id)))]);
        }
      } else {
        setGrantedPortfolios([...grantedPortfolios.filter(id => id !== portfolioId)]);
      }
    }
  };
  const getIsAccessGranted = function () {
    let propertyId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let portfolioId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (propertyId === null && portfolioId) {
      const matchingItemIndex = grantedPortfolios !== null && !!(grantedPortfolios !== null && grantedPortfolios !== void 0 && grantedPortfolios.length) ? grantedPortfolios.findIndex(item => item === portfolioId) : -1;
      return matchingItemIndex !== -1;
    }
    if (propertyId) {
      const matchingPortfolioItemIndex = grantedPortfolios !== null && !!(grantedPortfolios !== null && grantedPortfolios !== void 0 && grantedPortfolios.length) ? grantedPortfolios.findIndex(item => item === portfolioId) : -1;
      if (matchingPortfolioItemIndex !== -1) {
        return true;
      }
      const matchingItemIndex = grantedProperties !== null && !!(grantedProperties !== null && grantedProperties !== void 0 && grantedProperties.length) ? grantedProperties.findIndex(item => item === propertyId) : -1;
      return matchingItemIndex !== -1;
    }
  };
  const _useState13 = useState(USER_ROLES_BY_NAME.PropertyManagerAccountHolder),
    _useState14 = _slicedToArray(_useState13, 2),
    userRole = _useState14[0],
    setUserRole = _useState14[1]; // NOTE: PropertyManagerAccountHolder || PropertyManagerRegular

  const formik = useFormik({
    initialValues: newTeamMemberValues,
    validationSchema: newTeamMemberSchema,
    onSubmit: async values => {
      const phoneCode = store.account.featureFlagsStore.isUkrainianMobileCode ? '+38' : '+1';
      const teamMemberDataObj = {
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        phone: !!values.phone ? "".concat(phoneCode).concat(values.phone) : null,
        teamRole: userRole
      };
      const resp = await store.account.inviteNewUserV2Async.run(beforeSubmitDataValidation(teamMemberDataObj));
      if (!resp || !resp.isSuccessful) {
        return;
      }
      const newTeamMemberResp = await store.teamMembers.createNewTeamMemberAsync.run({
        accountId: resp.response
      });
      if (!newTeamMemberResp || !newTeamMemberResp.isSuccessful) {
        return;
      }
      if (!!(grantedProperties !== null && grantedProperties !== void 0 && grantedProperties.length) || !!(grantedPortfolios !== null && grantedPortfolios !== void 0 && grantedPortfolios.length)) {
        const setTeamMemberAccessSettings = await store.account.setTeamMemberAccessAsync.run({
          accountId: resp.response,
          userRole: userRole,
          propertyIds: grantedProperties,
          portfolioIds: grantedPortfolios
        });
        if (!setTeamMemberAccessSettings || !setTeamMemberAccessSettings.isSuccessful) {
          return;
        }
      }
      toast('success', {
        body: [t('general.successfully_created')]
      });

      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      handleModalClose && handleModalClose();
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      triggerRefresh && triggerRefresh();
    }
  });
  const handleSearchKeyChange = e => {
    setSearchKey(e.target.value);
  };
  const fetchPortfolios = async () => {
    const resp = await store.portfolios.getPortfoliosDashboardAsync.run();
    if (resp !== null && resp !== void 0 && resp.isSuccessful) {
      setPortfoliosData(resp === null || resp === void 0 ? void 0 : resp.response.portfolios);
    }
  };
  const fetchData = async () => {
    setIsLoading(true);
    await fetchPortfolios();
    setIsLoading(false);
  };
  useEffect(() => {
    if (!isOpenInternal) {
      // store.addNewProperty.contactInformation.resetNotSavedNewUnitTeamMember();
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpenInternal]);
  const runEmailValidation = async email => {
    try {
      var _resp$response;
      setEmailValidation(prev => _objectSpread(_objectSpread({}, prev), {}, {
        isValidating: true
      }));
      const resp = await store.account.validateEmailAsync.run({
        email
      });
      const isInvalid = !!(resp !== null && resp !== void 0 && resp.isSuccessful) && ((_resp$response = resp.response) === null || _resp$response === void 0 ? void 0 : _resp$response.result) !== 'deliverable';
      setEmailValidation(prev => _objectSpread(_objectSpread({}, prev), {}, {
        isInvalid,
        showWarning: isInvalid
      }));
      return isInvalid;
    } catch (_unused) {
      setEmailValidation(prev => _objectSpread(_objectSpread({}, prev), {}, {
        isInvalid: false
      }));
      return false;
    } finally {
      setEmailValidation(prev => _objectSpread(_objectSpread({}, prev), {}, {
        isValidating: false
      }));
    }
  };
  const handleEmailBlur = e => {
    const email = e.target.value;
    if (!email) return;
    formik.handleBlur(e);
    if (!YEmailValidateDefault.isValidSync(email)) return;
    const validation = runEmailValidation(email);
    emailValidationRef.current = validation;
    validation.finally(() => {
      if (emailValidationRef.current === validation) emailValidationRef.current = null;
    });
  };
  const handleEmailChange = e => {
    formik.handleChange(e);
    setEmailValidation(prev => _objectSpread(_objectSpread({}, prev), {}, {
      isInvalid: false
    }));
    emailValidationRef.current = null;
  };
  const handleFormSubmit = async e => {
    e.preventDefault();
    const pendingEmailValidation = emailValidationRef.current;
    if (pendingEmailValidation) {
      const isInvalid = await pendingEmailValidation;
      if (isInvalid) return;
    }
    if (emailValidation.isInvalid) return;
    formik.handleSubmit();
  };
  return /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement("form", {
    className: classes.form,
    onSubmit: handleFormSubmit
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.formContent
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('general.personal_details')), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 24,
    columnSpacing: 10
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    id: "firstName",
    name: "firstName",
    label: t('general.first_name'),
    variant: "outlined",
    value: (_formik$values = formik.values) === null || _formik$values === void 0 ? void 0 : _formik$values.firstName,
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: e => {
      formik.handleChange(e);
    },
    error: formik.touched.firstName && Boolean(formik.errors.firstName),
    helperText: formik.touched.firstName && translate(formik.errors.firstName, t)
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    id: "lastName",
    name: "lastName",
    label: t('general.last_name'),
    variant: "outlined",
    value: (_formik$values2 = formik.values) === null || _formik$values2 === void 0 ? void 0 : _formik$values2.lastName,
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: e => {
      formik.handleChange(e);
    },
    error: formik.touched.lastName && Boolean(formik.errors.lastName),
    helperText: formik.touched.lastName && translate(formik.errors.lastName, t)
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 7
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    fullWidth: true,
    error: formik.touched.email && Boolean(formik.errors.email),
    onBlur: handleEmailBlur,
    onChange: handleEmailChange
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "email"
  }, t('general.email_address')), /*#__PURE__*/React.createElement(OutlinedInput, {
    id: "email",
    type: "email",
    label: t('general.email_address'),
    value: formik.values.email,
    endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end",
      type: "infoTooltip"
    }, emailValidation.isValidating ? /*#__PURE__*/React.createElement(CircularProgress, {
      size: 20
    }) : /*#__PURE__*/React.createElement(ExpandedTooltip, {
      placement: "top",
      title: emailTooltipText,
      type: "grey"
    }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
      type: "question"
    }))))
  }), formik.touched.email && !!formik.errors.email && /*#__PURE__*/React.createElement(FormHelperText, null, translate(formik.errors.email, t)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 5
  }, /*#__PURE__*/React.createElement(InputMask, {
    mask: "999-999-9999",
    value: formik.values.phone,
    onChange: e => {
      formik.handleChange(e);
    },
    onBlur: e => {
      if (!formik.touched.phone && /\d/.test(e.target.value)) formik.setFieldTouched('phone', true);
    }
  }, inputProps => /*#__PURE__*/React.createElement(TextField, _extends({}, inputProps, {
    type: "tel",
    fullWidth: true,
    id: "phone",
    name: "phone",
    variant: "outlined",
    label: t('general.phone_number'),
    error: formik.touched.phone && Boolean(formik.errors.phone),
    helperText: formik.touched.phone && translate(formik.errors.phone, t)
  })))))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.roleSelector
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, 'Role: '), /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: userRole,
    size: "small",
    exclusive: true,
    onChange: (e, value) => setUserRole(value)
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: USER_ROLES_BY_NAME.PropertyManagerAccountHolder
  }, 'Property manager account holder'), /*#__PURE__*/React.createElement(ToggleButton, {
    value: USER_ROLES_BY_NAME.PropertyManagerRegular
  }, 'Property manager')))), userRole === USER_ROLES_BY_NAME.PropertyManagerAccountHolder && /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Alert, {
    severity: "info",
    icon: false,
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, 'The Property manager account holder has full access to manage the account, including creating and deleting portfolios or properties. They can invite team members, assign them to specific portfolios, and move properties between different portfolios as needed.'))), userRole === USER_ROLES_BY_NAME.PropertyManagerRegular && /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('team_page.manage_access'))), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.searchField
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "charges-search",
    label: t('general.search'),
    variant: "outlined",
    value: searchKey,
    onChange: handleSearchKeyChange,
    fullWidth: true
  })))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.xsSection, " ").concat(classes.portfoliosAccordions)
  }, !!(portfoliosData !== null && portfoliosData !== void 0 && portfoliosData.length) && !!((_portfoliosData$filte = portfoliosData.filter(portfolio => {
    const searchPhrase = new RegExp(searchKey, 'gi');
    return searchKey.length > 0 ? " ".concat(portfolio.name).search(searchPhrase) > 0 : true;
  })) !== null && _portfoliosData$filte !== void 0 && _portfoliosData$filte.length) ? portfoliosData.filter(portfolio => {
    const searchPhrase = new RegExp(searchKey, 'gi');
    return searchKey.length > 0 ? " ".concat(portfolio.name).search(searchPhrase) > 0 : true;
  }).map(portfolio => /*#__PURE__*/React.createElement(PortfolioAccordionItem, {
    key: portfolio.id,
    portfolioDataExt: portfolio,
    handleGrantAccess: handleGrantAccess,
    getIsAccessGranted: getIsAccessGranted
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    style: {
      textAlign: 'center'
    }
  }, t('team_page.no_matches_found'))), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement("img", {
    alt: "portfolios or properties missing data",
    src: warningImg,
    height: '200px',
    width: '100%'
  })))))), /*#__PURE__*/React.createElement("div", {
    className: classes.formFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    type: "button",
    onClick: handleModalClose,
    'custom-attribute': '270-add-teammember-v2-modal'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "contained",
    disabled: !formik.isValid || !Object.keys(formik.touched).length || emailValidation.isInvalid,
    'custom-attribute': '271-add-teammember-v2-modal'
  }, t('add_new_property_flow.add_team_member')))))), /*#__PURE__*/React.createElement(Dialog, {
    open: emailValidation.showWarning,
    onClose: () => setEmailValidation(prev => _objectSpread(_objectSpread({}, prev), {}, {
      showWarning: false
    }))
  }, /*#__PURE__*/React.createElement(DialogTitle, null, "Email Validation"), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement(DialogContentText, null, "The email address you entered appears to be invalid or undeliverable. Please verify the email address and try again.")), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(Button, {
    onClick: () => setEmailValidation(prev => _objectSpread(_objectSpread({}, prev), {}, {
      showWarning: false
    })),
    variant: "contained"
  }, "OK"))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading || store.account.inviteNewUserV2Async.inProgress || store.teamMembers.createNewTeamMemberAsync.inProgress
  })));
});